import React, { useContext, useState } from 'react'
import DetailCartTable from '../Tables/DetailCartTable'

import "./CartDetailComponent.css"
import { Alert, Button, Tabs } from 'antd'
import { PromiseSesionContext } from '../../Machines/ErrorMachine'
import { CartUnit } from '../../Models/CartUnit'
import { CopyOutlined, DeleteOutlined, QuestionCircleOutlined, TagOutlined } from '@ant-design/icons'
import DetailCartsTable from '../Tables/DetailCartsTable'
import { CartUnitCards } from '../../Models/CartUnitCards'
import { Monitor } from '../../Models/Monitor'
import { addMonitor } from '../../Api/Monitor'
import { MenuItem } from '../../Models/ModalItem'
import ContactForm from '../ContactForm/ContactForm'
import ModalMenuItem from '../ModalMenuItem/ModalMenuItem'

import pako from 'pako';
interface Props{
  closeModal?:() => void
}

const CartDetailComponent = ({closeModal}:Props) => {
  const {cart, sendCart, cartCard, sendCartCard, sendError} = useContext(PromiseSesionContext);
  const [open, setOpen] = useState<boolean>(false);
  const confirmOrder = () => {
    const mensaje = handleText()
    const numeroTelefono = '584126398423'; // Reemplaza con el número de teléfono

    const urlWhatsApp = `https://wa.me/${numeroTelefono}?text=${encodeURIComponent(mensaje)}`;
    window.open(urlWhatsApp, '_blank'); 

  }

  const deleteCart = () => {
    localStorage.removeItem("cart")
    localStorage.removeItem("cartCard")

    sendCart({type: "DELETE", data:{}})
    sendCartCard({type: "DELETE", data:{}})

  }

          const sendMonitor = async (message:string)=>{
            try  
            {let user:string= localStorage.getItem("user") || ""
    
              let monitor:Monitor={
                  action:message,
                  user:user
              }
              await addMonitor(monitor)}
              catch(error){}
          }

  const orderArrayCards =()=>{
    const productosOrdenados = [...cartCard.context.cart.productos].sort((a, b) => {
      // Nivel 1: Ordenar por rarity
      const rarityA = a.producto.product.pokemonCard[0].rarity;
      const rarityB = b.producto.product.pokemonCard[0].rarity;
      if (rarityA < rarityB) return -1;
      if (rarityA > rarityB) return 1;

      // Nivel 2: Si rarity es igual, ordenar por supertype
      const supertypeA = a.producto.product.pokemonCard[0].supertype;
      const supertypeB = b.producto.product.pokemonCard[0].supertype;
      if (supertypeA < supertypeB) return -1;
      if (supertypeA > supertypeB) return 1;

      // Nivel 3: Si rarity y supertype son iguales, ordenar por el primer tipo
      if(a.producto.product.pokemonCard[0].types &&  b.producto.product.pokemonCard[0].types){
        const typeA = a.producto.product.pokemonCard[0].types[0];
        const typeB = b.producto.product.pokemonCard[0].types[0];
        if (typeA < typeB) return -1;
        if (typeA > typeB) return 1;
      }


      // Si todo es igual, no se cambia el orden.
      return 0;
    });
    console.log("card", productosOrdenados)
  return productosOrdenados
  }

  interface CompactItem {
  id: number;
  cant: number;
}

  const compressAndEncode = () => {
    try {

      const compactArray: CompactItem[] = cartCard.context.cart.productos.map((item:CartUnitCards )=> ({
        id: item.producto.id,
        cant: item.cantidad
      }));
      // 1. Convertir el objeto JSON a una cadena
      const jsonString = JSON.stringify(compactArray);

      // 2. Comprimir la cadena a bytes
      const compressed: Uint8Array = pako.deflate(jsonString);

      // Opcional: Codificar los bytes a Base64 para transportarlos como texto seguro
      // (aunque pako.deflate puede devolver una cadena, es útil si necesitas Base64)
      const compressedBase64 = btoa(String.fromCharCode.apply(null, compressed as any));
      return compressedBase64


    } catch (error) {
      console.error("Error al comprimir los datos:", error);
      return ""
    }
  };

  const handleText = ():string => {

    if(cart.context.cart.productos.length===0 && cartCard.context.cart.productos.length===0 ){
      return "Sin carrito de compras"
    }

    let mensaje = '¡Hola! Quiero hacer un pedido:\n\n';

    if(cart.context.cart.productos.length){
    mensaje += 'Productos:\n';

      cart.context.cart.productos.forEach((item:CartUnit) => {
        mensaje += `- ${item.producto.name} (${item.producto.language}) -   x \ ${item.cantidad} \( ${ item.producto.discount_price ? item.producto.discount_price :item.producto.price}$ c/u)\n`;
      });
    mensaje += '\n';

    

    }

    if(cartCard.context.cart.productos.length){
    mensaje += 'Cartas:\n';

      orderArrayCards().forEach((item:CartUnitCards) => {
      mensaje += `- ${item.producto.product.name} - ${item.producto.product.pokemonCard[0].name}${item.producto.product.card_type!=="rare"? ` (${item.producto.product.card_type}) ` : ""} x \ ${item.cantidad} \( ${item.producto.product.price}$ c/u)\n`;
      });
    mensaje += '\n';

    mensaje += 'Orden: '+ compressAndEncode();


    }


    mensaje += `\nTotal: ${(cart.context.cart.total+cartCard.context.cart.total).toFixed(1)}$`;
    mensaje += `\n`;
    mensaje += `\nMétodo de pago: (Pago móvil, PayPal, Divisas, Zelle, binance)`;
    mensaje += `\nVuelto: (Aplica si cancela en divisas)`;
    mensaje += `\nForma de entrega: (Pickup, envió nacional o delivery)`;



    return mensaje
  };

  const handleCopyClick = async () => {
    sendMonitor("Copio el carrito")
    try {
      const textToCopy = handleText();
      await navigator.clipboard.writeText(textToCopy);

      sendError({type: "ERROR", data:{message:"El texto se copió en el portapapeles, puede completar el pedido por WhatsApp (04126398423)", type:"success"}})

      // Opcional: Mostrar una notificación al usuario
      // alert('Texto copiado al portapapeles!');
    } catch (err) {
      console.log(err)
      sendError({type: "ERROR", data:{message:"Error Copiando el contenido"}})
    }
  };

    let menuItem:MenuItem =   {
        label: <span></span>,
        title: "Atención personalizada",
        key: '1',
        icon: <TagOutlined />,
        component: <ContactForm description={handleText()} />,
        // component: <></>,
        type: 'CONTENT',
        items: [],
        size: 'small',
        onConfirm: () => {},
    
      }

  return (
    <>
    <ModalMenuItem menuItem={menuItem} open={open} setOpen={setOpen} updateSize size='normal' />
    <div className='CartDetailComponent'>
        

          <Tabs
          style={{width:"100%"}}
            defaultActiveKey="1"
            items={[
              {
                label: 'Productos',
                key: '1',
                children: <DetailCartTable closeModal={closeModal} />,
              },
              // {
              //   label: 'Cartas',
              //   key: '2',
              //   children: <DetailCartsTable closeModal={closeModal} />,
              // },

            ]}
          />
        {cart.context.hasDiscountItem && <Alert message={"Ten en cuenta: El envío gratis no aplica en productos con descuento"} type='warning' showIcon></Alert>}
        <Alert message={(cart.context.cart.total + cartCard.context.cart.total) === 0 ? "Tu carrito está vacío. Recuerda que por compras iguales o mayores a $50, tu delivery o envío es gratis (aplican restricciones de zona, ¡consulta las tuyas!).":(cart.context.cart.total +cartCard.context.cart.total)< 50 ?  `¡Te falta poco para el envío gratis! Agrega productos por ${(50 - (cart.context.cart.total+cartCard.context.cart.total)).toFixed(1) } más y tu pedido podría tener delivery o envío sin costo. Recuerda que aplican restricciones de zona, ¡consulta las tuyas!`  : "¡Felicidades! Tu compra ya aplica para delivery o envío gratis. Disfruta de este beneficio en tu pedido. Ten en cuenta que algunas zonas están excluidas, ¡no olvides consultarlas!"} type={(cart.context.cart.total+cartCard.context.cart.total)< 50 ? "info" : "success"} showIcon />
        <div className='FooterCartDetailComponent'>
          {/* <Button type='default' onClick={()=>{deleteCart()}}> Borrar carrito</Button> */}

          {(cart.context.cart.total + cartCard.context.cart.total) > 0 &&<div>
            <span>Total: ${(cart.context.cart.total + cartCard.context.cart.total).toFixed(1)}</span>

            {/* <Button type='primary' onClick={()=>{confirmOrder()}} > Confirmar orden </Button> */}
          </div>}
            {(cart.context.cart.total + cartCard.context.cart.total) > 0 && <Button type='default' onClick={()=>{deleteCart();sendMonitor("Elimino carrito de compras")}}><DeleteOutlined /> Borrar carrito</Button>}

        </div>

        <div className='FooterCartDetailComponent'>
          <Button type='default' onClick={()=>{setOpen(true)}}><QuestionCircleOutlined /> Solicitar ayuda</Button>

          <div className='CartDetailComponent-buttons'>
            {/* <span>Total: ${cart.context.cart.total}</span> */}
            <Button type='default' disabled={(cart.context.cart.productos.length + cartCard.context.cart.productos.length)==0} onClick={handleCopyClick}><CopyOutlined /></Button>
            <Button type='primary' disabled={(cart.context.cart.productos.length + cartCard.context.cart.productos.length)==0} onClick={()=>{confirmOrder();sendMonitor("Selecciono completar compra")}} > Completar compra</Button>
          </div>

        </div>

    </div>
    </>

  )
}

export default CartDetailComponent